<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
    >
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width:100%;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:100%;" />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div v-if="row.goodsSize">
            <span class="mr-1">SIZE:</span>
            <span>{{ row.goodsSize }}</span>
          </div>
          <div v-if="row.goodsColor || row.goodsColorEn">
            <span class="mr-1">COLOR:</span>
            <span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <div>
            <span class="mr-1">NC:</span>
            <span>{{ row.ncNo }}</span>
          </div>
          <div>
            <span class="mr-1">SKU:</span>
            <span>{{ row.amzSkuNo }}</span>
          </div>
          <div v-if="row.eanCode">
            <span class="mr-1">UPC:</span>
            <span>{{ row.eanCode }}</span>
          </div>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
}
</script>
